module.exports = __webpack_public_path__ + "img/bq.6314b3cf.svg";